import { IonButton, IonIcon, useIonAlert } from "@ionic/react";
import DeleteIcon from '@mui/icons-material/Delete';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import { TextField } from "@mui/material";
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { add, remove } from "ionicons/icons";
import { useCallback, useEffect, useRef, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import lotsController from "../../../../../../barrel/controllers/lotsController";
import stockManagementController from "../../../../../../barrel/controllers/stockManagementController";
import warehouseLocationsController from "../../../../../../barrel/controllers/warehouseLocationsController";
import warehouseController from "../../../../../../barrel/controllers/warehousesController";
import useFeedbackService from "../../../../../../barrel/hooks/useFeedbackService";
import useHxfTranslation from "../../../../../../barrel/hooks/useHxfTranslation";
import usePrevious from "../../../../../../barrel/hooks/usePrevious";
import useProductivityScale from "../../../../../../barrel/hooks/useProductivityScale";
import HxfNumberFormat from "../../../../../../barrel/services/hxfNumberFormat";
import ScannablesService from "../../../../../../barrel/services/ScannablesService";
import { IHxfBarcodeSettings } from "../../../../../../components/HxfBarcodeScanner/HxfBarcodeScanner";
import DefineStockLocationPopup from "../../../../../CustomElements/statePopups/defineStockLocationPopup/DefineStockLocationPopup";
import ScanBarcodePopup from "../../../../../FeaturePages/ProductionOrders/Standard/ScanBarcodePopup/ScanBarcodePopup";
import { dispatchProductionOrderSelectionStore, useProductionOrderSelectionStore } from "../../../../../FeaturePages/ProductionOrders/Standard/store/productionOrderSelectionStore";
import HxfExistingLotsButton, { IExistLotResultLocation } from "../../../../HxfExistingLotsButton/HxfExistingLotsButton";
import HxfSelectorField from "../../../../HxfSelectorField/HxfSelectorField";
import HxfStagedLotsButton from "../../../../HxfStagedLotsButton/HxfStagedLotsButton";
import DefineProductQuantityPopup from "../../../../statePopups/defineProductQuantityPopup/DefineProductQuantityPopup";
import TaskProgressBarV2 from "../../../../TaskProgressBarV2/TaskProgressBarV2";
import { useActionScreenManagerStore } from "../../ActionScreensManager/ActionScreenManagerStore";
import ActionScreenTopBar from "../Components/ActionScreenTopBar";
import styles from "./ActionScreenAskBomConsumptions.module.scss";
import ActionScreenAskBomConsumptionsConfirmationButtons from "./ActionScreenAskBomConsumptionsConfirmationButtons";
import {
  dispatchActionScreenAskBomConsumptionsStore,
  useActionScreenAskBomConsumptionsStore
} from "./ActionScreenAskBomConsumptionsStore";
import ExistingLotsPopup from "./Subpopups/ExistingLotsPopup/ExistingLotsPopup";
import StagedLotsPopup from "./Subpopups/StagedLotsPopup/StagedLotsPopup";
import RandomizationService from "../../../../../../barrel/services/randomizationService";
import LoadingSpinnerImg from "../../../../../../components/UIComps/LoadingSpinnerImg/LoadingSpinnerImg";

function ActionScreenAskBomConsumptions(props: any) {
  const [present] = useIonAlert();

  const ALLOW_BARCODESCANNER_TO_ALSO_SCAN_QRCODES = true; //for physical scanners that scan qr and barcodes
  const currentActionScreenManager = useActionScreenManagerStore();
  const autoConfirmAfterDispatchingConsumptions = useRef(false);
  const [didMount, setDidMount] = useState(false);
  const screenStore = useActionScreenAskBomConsumptionsStore();
  const productionOrderSelectionStore = useProductionOrderSelectionStore();
  const [warehouseSearchFilters, setWarehouseSearchFilters] = useState({});
  const [lotSearchFilters, setLotSearchFilters] = useState({});
  const {t} = useHxfTranslation();
  const productivityScale:any = useProductivityScale();
  const feedbackService = useFeedbackService();
  const triggerFinishScanBarcodeSettings = useRef<any>(null);
  const [triggerOnFinishScan,setTriggerOnFinishScan] = useState(null);
  const prevTriggerOnFinishScan = usePrevious(triggerOnFinishScan);
  const [askStagedLotSelection,setAskStagedLotSelection] = useState<any>(null);
  const [isEdittingQtyCons,setIsEdittingQtyCons] = useState<any>(null);

  const [mapConsumptionLocationStockVerified ,setMapConsumptionLocationStockVerified] = useState<any>({});
  //const [askExistingLotSelection,setAskExistingLotSelection] = useState<any>(null);

  const [confirmedIgnoreBecommingNegative, setConfirmedIgnoreBecommingNegative] = useState(false);
  console.log(
    "Production order selection store ",
    productionOrderSelectionStore
  );
  console.log("SCREEN STORE: ", screenStore);
  const [rerenderListKey, setRerenderListKey] = useState(0);

  const [addingFillConsumption, setAddingFillConsumption] = useState<any>(null);


  const findConsumptionByKey  = (mapConsumptions:any, key: string) => {
    for (let i = 0; i < mapConsumptions.length; i++) {
     
      if (mapConsumptions[i].key === key) {
        return mapConsumptions[i];
      }
    }

    return null;
  }

  const replaceConsumptionObjByKey = (
    mapConsumptions: any,
    key: string,
    updatedConsumptionObj: any
  ) => {
    for (let i = 0; i < mapConsumptions.length; i++) {
      if (mapConsumptions[i].key === key) {
        mapConsumptions[i].consumptionObj = updatedConsumptionObj;
      }
    }
    return mapConsumptions;
  }

  const getMapArrayFromBom = useCallback(() => {
    let consumeSpecificMaterial = currentActionScreenManager?.currentActionConfig?.consumeSpecificMaterial === 1 ? true : false;
    let consumeBomList = currentActionScreenManager?.currentActionConfig?.consumeBomList === 1 ? true : false;

    let defBomQtyZero = currentActionScreenManager?.currentActionConfig?.defBomQtyZero === 1 ? true : false;
    // let specificMaterialToConsume = currentActionScreenManager?.currentActionConfig?.selectedProductComponentsConsume;
   
    let currentIdOperationProduct = productionOrderSelectionStore.currentOperation.Id;
    let productBomArray = productionOrderSelectionStore?.product?.arrayProductBom;
    let arrayBom = [];

    for (let i = 0; i < productBomArray.length; i++) {
      if(consumeBomList || (productBomArray[i]?.Id_OperationProduct === null || productBomArray[i].Id_OperationProduct === currentIdOperationProduct)){

        if(defBomQtyZero || parseFloat(productBomArray[i].Quantity) === 0){
          productBomArray[i].Quantity = "";
        }
        arrayBom.push(
          productBomArray[i]
        );
      }
    }
    
    return arrayBom;
  }, [productionOrderSelectionStore,currentActionScreenManager?.currentActionConfig?.consumeSpecificMaterial]);

  const getFullListingConsumptions = () => {
    let arrayBom = getMapArrayFromBom();

    return arrayBom;
  }

  const getMapArrayFixedVariables = (indexBoMElement: number) => {
    let arrayProductBom = getMapArrayFromBom();

    let bomChild = arrayProductBom[indexBoMElement];
    if (bomChild?.productFixedVariables) {
      let bomChildFixedVariables = bomChild["fixedVariables"];
      bomChildFixedVariables = JSON.parse(bomChildFixedVariables);

      let bomChildProductFixedVariables = bomChild["productFixedVariables"];
      bomChildProductFixedVariables = JSON.parse(bomChildProductFixedVariables);

      for (let i = 0; i < bomChildProductFixedVariables.length; i++) {
        let labelBuilder = "";

        let idFixedVariable = parseInt(
          bomChildProductFixedVariables[i].Id_FixedVariable
        );
        for (let j = 0; j < bomChildFixedVariables.length; j++) {
          if (idFixedVariable === parseInt(bomChildFixedVariables[j]["Id"])) {
            labelBuilder =
              "(" +
              bomChildFixedVariables[j]["code"] +
              ") " +
              bomChildFixedVariables[j]["name"];
            break;
          }
        }
        bomChildProductFixedVariables[i]["temp_labelPv"] = labelBuilder;
      }
      return bomChildProductFixedVariables;
    }
    return [];
  };
  
  const getArrayParameterizedVariables = (indexBoMElement: number) => {
    let arrayProductBom = getMapArrayFromBom();

    let bomChild = arrayProductBom[indexBoMElement];
    return bomChild?.arrayProductParameterizedVariables ? bomChild?.arrayProductParameterizedVariables : [];
  };

  const getStagedMaterial = () => {
    //let stagedMaterial = currentActionScreenManager?.currentActionConfig?._stagedArrayMaterialComponentsData;

    return productionOrderSelectionStore.stagedMaterial;
  }


  const checkIfFailedVerifyConsumptionLine = (obj:any) => {

    if(currentActionScreenManager?.currentActionConfig?.verifyStockPerConsumption !== 1){
      return false;
    }
    if(obj?._stockVerifyIdentifier && mapConsumptionLocationStockVerified?.[obj?._stockVerifyIdentifier]?.failedVerify){
      return true;
    }

    return false;
  }
  const checkIfWaitingConsumptionLineIsVerifyingStock = (obj:any) => {

    if(currentActionScreenManager?.currentActionConfig?.verifyStockPerConsumption !== 1){
      return false;
    }
    if(obj?._stockVerifyIdentifier && !mapConsumptionLocationStockVerified?.[obj?._stockVerifyIdentifier]){
      return true;
    }

    return false;
  }

  const willConsumptionBecomeNegative = (obj:any) => {
    if(currentActionScreenManager?.currentActionConfig?.verifyStockPerConsumption !== 1){
      return false;
    }
    return mapConsumptionLocationStockVerified?.[obj?._stockVerifyIdentifier]?.availableQuantityAfterConsumption < 0;
  }


  const verifyStock = (objCons:any) => {
   
    let idProduct = objCons?.Id_Product;
    let arrayProductParameterizedVariables= objCons?.arrayProductParameterizedVariables;
    let idLot = objCons?.Id_Lot;
    let idWarehouse = objCons?.Id_Warehouse;
    let idWarehouseLocation = objCons?.Id_WarehouseLocation;
    let verificationIdentifier = objCons?._stockVerifyIdentifier;
    let productFilters = [{
        Id_Product:idProduct,
        exactProductStockLocation:true,
        exactProductParameterizedVariables:true,
        stockMovement_productParameterizedVariables: arrayProductParameterizedVariables ? arrayProductParameterizedVariables : null,
        stockLocation:{
            Id_WarehouseLocation:idWarehouseLocation,
            Id_Warehouse:idWarehouse,
            Id_Lot:idLot
        }

    }];

    //calculate available stock at whlocation
    stockManagementController().getProductsStockAtLocation(productFilters,{lotTraceability:false,notInStaging:true}).then((res) => {
       
        let result = res?.data?.response?.data;

        if(!result || result.length === 0){
            throw "unexpected stock not found";
        }
        let availableQuantity = 0;
        let stockResult = result[0].stockResult;

        
        
        if(stockResult){
            for(let i = 0; i<stockResult.length; i++){
                availableQuantity += stockResult[i].Quantity;
            }
        }
        
        
        let consumingQty = parseFloat(objCons.Quantity);
        let nextQuantity = availableQuantity - consumingQty;
        let resObj = {availableQuantity:availableQuantity, availableQuantityAfterConsumption: nextQuantity};

        if(verificationIdentifier){
          let newMapConsStockVerified = {...mapConsumptionLocationStockVerified};
          newMapConsStockVerified[verificationIdentifier] = resObj;
          setMapConsumptionLocationStockVerified(newMapConsStockVerified);
        }

        
    }).catch((res:any) => {
        if(verificationIdentifier){
          let newMapConsStockVerified = {...mapConsumptionLocationStockVerified};
          newMapConsStockVerified[verificationIdentifier] = {failedVerify:true};
          setMapConsumptionLocationStockVerified(newMapConsStockVerified);
        }
        feedbackService.notifyToast(t("generic.critical.error"), "error");
    });
  }
  const finishAddingFillConsumption = (productKey:any,newFillConsumption:any) => {
    
    let currentMapFillConsumptions = JSON.parse(JSON.stringify(screenStore.mapFillerConsumptions));

    let currentArrConsumptions = currentMapFillConsumptions?.[productKey] ? currentMapFillConsumptions?.[productKey] : [];


    let verifyStockPerConsumption = currentActionScreenManager?.currentActionConfig?.verifyStockPerConsumption === 1;
    let verificationIdentifier:any = null;
    if(verifyStockPerConsumption){
      verificationIdentifier = RandomizationService().generateRandomString(15);
      newFillConsumption._stockVerifyIdentifier = verificationIdentifier;
    }

    currentArrConsumptions.push(newFillConsumption);

    currentMapFillConsumptions[productKey] = currentArrConsumptions;

    dispatchActionScreenAskBomConsumptionsStore({
      type: "SET_MAP_FILLER_CONSUMPTIONS",
      payload: currentMapFillConsumptions,
    });

    setAddingFillConsumption(null);

    if(verifyStockPerConsumption){


      verifyStock(newFillConsumption);
    }
  
  }
  
  const getShowInsufficientError = (index:any) => {
    let arrayProductBom = getMapArrayFromBom();
    let bomChild = arrayProductBom[index];
    let currentMapConsumptions = screenStore.mapConsumptions;
    let consumption = null;
    let loadedQty = 0;
    consumption = findConsumptionByKey(
      currentMapConsumptions,
      buildKeyForChildProduct(bomChild)
    );

    if (consumption === null) {
      //didnt manually change
      //loadedQty = bomChild.Quantity;
      loadedQty = 0;
    } else {
      loadedQty = consumption.consumptionObj.Quantity;
    }
    return (
      <div>
      {consumption?.consumptionObj
        ?.showInsufficientQuantityAtLocationError === true && (
        <div className={styles.notEnoughtAvailableQtyLabel}>
          {t("not.enought.qty.available.at.this.location")}
        </div>
      )}
      </div>
    )
  }


  const getFilledQuantity = (indexBomChild:number) => {
    let currentActionConfig = currentActionScreenManager?.currentActionConfig;

    let arrayProductBom = getMapArrayFromBom();
    let bomChild = arrayProductBom[indexBomChild];
    let productKey = buildKeyForChildProduct(bomChild);
    let currentMapFillConsumptions = screenStore.mapFillerConsumptions;
    let currentArrConsumptions = currentMapFillConsumptions?.[productKey] ? currentMapFillConsumptions?.[productKey] : [];

    let totalQty = 0;
    for(let i = 0; i<currentArrConsumptions.length; i++){
      totalQty += currentArrConsumptions[i].Quantity;
    }
    
    return totalQty;
  }

  const getRequiredQuantity = (indexBoMChild:number) => {
    let currentActionConfig = currentActionScreenManager?.currentActionConfig;

    let arrayProductBom = getMapArrayFromBom();
    let bomChild = arrayProductBom[indexBoMChild];
    let key = buildKeyForChildProduct(bomChild);
    let currentMapConsumptions = screenStore.mapConsumptions;
  
    let loadedQty = 0;

    let consumption = null;
    consumption = findConsumptionByKey(
      currentMapConsumptions,
      buildKeyForChildProduct(bomChild)
    );

 

    if (consumption === null) {
      //didnt manually change
      //loadedQty = bomChild.Quantity;
      loadedQty = 0;
    } else {
      loadedQty = consumption?.consumptionObj?.Quantity ?  consumption?.consumptionObj?.Quantity : 0;
    }

    return loadedQty;
  }

  const checkHasQtyError = (consumption:any) =>{
  
    return consumption?.consumptionObj?.hasQuantityError;
  }
  const getFieldQuantityValue = (indexBoMChild:any) => {
    let loadedQty = getRequiredQuantity(indexBoMChild);


    return HxfNumberFormat().val(loadedQty);
  }
  const getFieldQuantity = (indexBoMChild: number) => {
    let currentActionConfig = currentActionScreenManager?.currentActionConfig;

    let arrayProductBom = getFullListingConsumptions(); //getMapArrayFromBom();
    let bomChild = arrayProductBom[indexBoMChild];
    let key = buildKeyForChildProduct(bomChild);
    let currentMapConsumptions = screenStore.mapConsumptions;
    let loadedQty:any = getRequiredQuantity(indexBoMChild);

    let consumption = null;
    consumption = findConsumptionByKey(
      currentMapConsumptions,
      buildKeyForChildProduct(bomChild)
    );

    
    
    let allowEditting = currentActionConfig?.allowConsumptionsQuantityChanging;
    
    if (allowEditting) {
      return (<>
          {isEdittingQtyCons?.index !== indexBoMChild ? (
              <div className={`${styles.qtyConsProductContainer} ${ checkHasQtyError(consumption) ? styles.qtyErrorContainer : ""}`} onClick={() => {
                setIsEdittingQtyCons({index:indexBoMChild});
              }}>
                  <div>{loadedQty === "" ? 0 : loadedQty}</div>
                
                    <div className={styles.editingQtyField}>
                      <EditIcon fontSize="small"/>
                    </div>
                  
            </div>
          ) : (
            <div className={styles.qtyFieldContainer}>

            <TextField
              autoFocus={true}
              onBlur={() => {
                setIsEdittingQtyCons(null);

  

                /*let latestDefinedQty = getFieldQuantityValue(indexBoMChild);
                //calculate the "remaining QTY relative to the original"
                let originalQty = arrayProductBom[indexBoMChild]?.Quantity ? HxfNumberFormat().val(arrayProductBom[indexBoMChild]?.Quantity) : 0;

                let newLineQty = parseFloat(originalQty) - parseFloat(latestDefinedQty);
                newLineQty = HxfNumberFormat().val(newLineQty);
                if(newLineQty > 0){
                  //only creates new line if there is remaining qty
                  
                  let newAdditionalExtraBom = [...screenStore.arrayAdditionalExtraBom];

                  let bomProductToClone = JSON.parse(JSON.stringify(arrayProductBom[indexBoMChild]));
                  bomProductToClone.Quantity = newLineQty;
                  newAdditionalExtraBom.push(bomProductToClone);
                }*/

             
              }}
              type={"number"}
              disabled={false}
              placeholder={t('quantity.short')}
              error={
                consumption?.consumptionObj
                  ?.showInsufficientQuantityAtLocationError || checkHasQtyError(consumption)
              }
              onChange={(evt) => {
                
                let newQty:any = evt.target.value;

                let isOnlyNumbers = /^\d+$/.test(newQty);
                if(isOnlyNumbers){
                  newQty = parseFloat(newQty);
                }
                
                
                if (parseFloat(newQty) < 0) {
                 
                } else {
                  let newMapConsumptions = screenStore.mapConsumptions;
  
                  let consumption = findConsumptionByKey(
                    newMapConsumptions,
                    key
                  );
                  let exists = true;
  
                  if (consumption === null) {
                    exists = false;
                    consumption = {
                      key: key,
                      consumptionObj: { Id_Product: bomChild["Id_ProductChild"] },
                    };
                  }
  
                  consumption.consumptionObj.Quantity = newQty;

                  //arrayAdditionalExtraBom
                  consumption.consumptionObj.showInsufficientQuantityAtLocationError =
                    false;
                  consumption.consumptionObj.hasQuantityError = false;
                  if (!exists) {
                    newMapConsumptions.push(consumption);
                  } else {
                    newMapConsumptions = replaceConsumptionObjByKey(
                        newMapConsumptions,
                        key,
                        consumption.consumptionObj
                      );
                  }
  
                  dispatchActionScreenAskBomConsumptionsStore({
                    type: "SET_MAP_CONSUMPTIONS",
                    payload: [...newMapConsumptions],
                  });
                }
              }}
              value={loadedQty}
              label={t("quantity.short")}
              variant="outlined"
            />
          </div>
          )}


      </>);
    } else {
      return (
        <div style={{display:'flex',justifyContent:'center'}}>
        <div style={{width:'100%;'}}>{getFieldQuantityValue(indexBoMChild)}</div>
        </div>
      )
    
    }
  };

  const processScanSelectionByProductAndLot = (idLot:any,idProduct:any) => {

    let productKey = buildKeyForChildProduct({
      Id_ProductChild:idProduct,
      arrayProductParameterizedVariables:[] // sfs02 does not support ppvvs
    }); 
    
    let productCons:any = null;
    let arrayBom = getMapArrayFromBom();
    for(let i = 0; i<arrayBom.length; i++){
      let bomPCKey = buildKeyForChildProduct(arrayBom[i]);
      if(bomPCKey === productKey){
        productCons = arrayBom[i];
      }
    }

   
    if(!productCons){
      feedbackService.notifyToast(t('product.not.part.of.bom'),"danger");
      return;
    }
    //todo check if product exists in the list if not show error

  
    lotsController().getLot({includeDefaultNoLot:true,includeWhLocation:true},idLot,null).then((res) => {

      let lotObj = res?.data;
      if(!lotObj?.Id){
        throw "unexpected product obj";
      }
     

      let whId = lotObj?.warehouse?.Id_Warehouse;

      let whLocId = lotObj?.warehouse?.warehouseLocation?.Id;

      let newFillCons = {
        productKey:productKey,
        productName:productCons.childProduct_name,
        productCode:productCons.childProduct_code,
        Id_Product:idProduct,
        Id_Lot:idLot,
        Id_Warehouse:whId,
        Id_WarehouseLocation:whLocId,
        lotData:{
          name:lotObj.name,
          code:lotObj.code
        },
        warehouseData:{
          name:lotObj.warehouse.name,
          code:lotObj.warehouse.code
        },
        warehouseLocationData:{
          name:lotObj.warehouse.warehouseLocation.name,
          code:lotObj.warehouse.warehouseLocation.code
        },
        _step:"QUANTITY_SET"
      };
      
      //TODO lotdata
      /*
      if(result?.lotData){
        newFillCons.lotData = {code:result?.lotData?.code};
      }
  
      if(result?.warehouseData){
        newFillCons.warehouseData = {code:result?.warehouseData?.code};
      }*/
  
      setAddingFillConsumption(newFillCons);
    }).catch((res) => {

      if(res?.response?.status === 404){
        feedbackService.notifyToast(t("lot.not.found"),"error");
        return;
      }
   
      feedbackService.notifyToast(t("generic.critical.error") + "!","error");
    });

  }
  const getMissingQty = (productKey:any) => {
    let scale = productivityScale.getProductivityScale();
    scale = HxfNumberFormat().val(scale);

    let arrayProductBom = getMapArrayFromBom();
    let totalRequiredQty = 0;
    for(let i = 0; i<arrayProductBom.length; i++){
    
      let key = buildKeyForChildProduct(arrayProductBom[i]);
      if(key === productKey){

        if(arrayProductBom[i]?.askUpdateConsLocStockQty === 1){
          return 0; //default to zero
        }
        let multiplier = getShouldMultiplyByProductivityScale() ? productivityScale.getProductivityScale() : 1;
        totalRequiredQty = arrayProductBom[i].Quantity*multiplier;
      }
     
    }

    totalRequiredQty = HxfNumberFormat().val(totalRequiredQty);
    let currentMapFillConsumptions = screenStore.mapFillerConsumptions;
    let currentArrConsumptions = currentMapFillConsumptions?.[productKey] ? currentMapFillConsumptions?.[productKey] : [];

    let addedQty = 0;
    for(let i = 0; i<currentArrConsumptions.length; i++){
      addedQty += currentArrConsumptions[i].Quantity;
    }
    
    let missingQty = 0;
    if(totalRequiredQty <= addedQty){
      return 0;
    }

    return totalRequiredQty - addedQty;
  }

  const getWarehouseLocationConsumptionField = (key: any) => {
   
    let currentMapConsumptions = screenStore.mapConsumptions;
    let consumption = findConsumptionByKey(
      currentMapConsumptions,
      key
    );

    if (
      consumption !== null &&
      consumption.consumptionObj.Id_WarehouseLocation !== 0 
      && consumption.consumptionObj.Id_WarehouseLocation !== null
    ) {
      let renderObj = {
        label: consumption.consumptionObj.temp_warehouseLocationLabel,
        value: consumption.consumptionObj.Id_WarehouseLocation,
      };
      return renderObj;
    }
    return null;
  };

  const getWarehouseConsumptionField = (key: any) => {
    let currentMapConsumptions = screenStore.mapConsumptions;
    let consumption = findConsumptionByKey(
      currentMapConsumptions,
      key
    );

    if (consumption !== null && consumption.consumptionObj?.Id_Warehouse && consumption.consumptionObj?.Id_Warehouse !== 0) {
      let renderObj = {
        label: consumption.consumptionObj.temp_warehouseLabel,
        value: consumption.consumptionObj.Id_Warehouse,
      };
      return renderObj;
    }
    return null;
  };

  const isPhysScannerEnabled = () => {
    return currentActionScreenManager?.currentActionConfig?.scannerSFS02 === 1;
  }
  
  const getPhysScanner = () => {
      
      let allowedScanFormats:any = [];

      if(currentActionScreenManager?.currentActionConfig?.scannerSFS02 === 1){
        allowedScanFormats.push({"type":"barcode39","pattern":"SFS02-[lot.id]-[product.id]"});
      }

      if(ALLOW_BARCODESCANNER_TO_ALSO_SCAN_QRCODES){
        if(currentActionScreenManager?.currentActionConfig?.scannerSFS02 === 1){
          allowedScanFormats.push({"type":"qrcode","pattern":"SFS02,[lot.id],[product.id]"});
        }
      }
  
      let barcodeSettings:IHxfBarcodeSettings = {
        initCameraOnStartUp:false,
        useCamera: false, //only show camera btn opt if qrcode is enabled
        useExternalDevice: true,
        allowedScanFormats: allowedScanFormats,
      };
  
      triggerFinishScanBarcodeSettings.current = barcodeSettings;
  
      return (
        <ScanBarcodePopup
        freeScannerMode={true}
        title="Scanner"
        ghostMode={true}
        visible={true}
        barcodeScannerSettings={barcodeSettings}
        onClosedCamera={() => {

        }}
        onFinishedScan={(result: any) => {
          setTriggerOnFinishScan(result);//Locate scanbarcodepopup, as scanbarcodepopup works on timer, eventually make this functionality inside hxfbcarcodescanner, create hxfbarcodescanner v2 or something
          //the onFinishedScan finished scan must not be called from a timer, to fix later, or it would be accessing unsynced states
          //this temporarily fixes it 
  
        }}
        onClosePopup={() => {
         
        }}
      />
      )
    
  }

  const getFillerColor = (index:any) => {

    let val1 = getFilledQuantity(index);
    let val2 = getRequiredQuantity(index);
    console.log("FC: ",val1, " ---- ", val2);
    val1 = HxfNumberFormat().val(val1);
    val2 = HxfNumberFormat().val(val2);
    let retVal = val1 >= val2 ? '#a0dca070' : null ;
    console.log("RET VAL: ", retVal);
    return retVal;
  }

  const getLotConsumptionFieldSelector = (key: any) => {
    let currentMapConsumptions = screenStore.mapConsumptions;
    let consumption = findConsumptionByKey(
      currentMapConsumptions,
      key
    );

    if (consumption !== null && consumption.consumptionObj.Id_Lot !== 0) {
      let renderObj = {
        label: consumption.consumptionObj.temp_lotLabel,
        value: consumption.consumptionObj.Id_Lot,
      };
      return renderObj;
    }
    return null;
  };
  const getLotConsumptionField = (key: any) => {
    let currentMapConsumptions = screenStore.mapConsumptions;
    let consumption = findConsumptionByKey(
      currentMapConsumptions,
      key
    );

    if (consumption !== null && consumption.consumptionObj.Id_Lot !== 0) {
      return consumption.consumptionObj.newLotCode;
    }
    return null;
  };
  const forceRerenderView = () => {
    setRerenderListKey(rerenderListKey + 1); //addreses listjsonOptions hxfselector useref detection
  };

  const finishConfirmStoreResult = (storeResult:any) => {
    let currentActionConfig = currentActionScreenManager?.currentActionConfig;
    let moloniDoNotSyncConsSMs = currentActionConfig?.moloniDoNotSyncConsSMs;

    if(moloniDoNotSyncConsSMs === 1){
      storeResult.moloniDoNotSyncConsSMs = 1;
    }
    props.callbackSuccessConfirm(storeResult);
  }

  const clickConfirm = () => {
    let currentActionConfig = currentActionScreenManager?.currentActionConfig;
    let isFillerMode = currentActionScreenManager?.currentActionConfig?.isFillerMode === 1;
    //todo get in any consumption has useConsLotAsFinalLotRef
    //if it does
    //get new lot code
    /*
    set pop
                    dispatchProductionOrderSelectionStore({
                        type: "SET_PRODUCTION_RECORD",
                        payload: resumedProduction,
                      });
    */
   //check if any consumption has useConsLotAsFinalLotRef

   let allowZeroQtyDueToInheritedZeroScale = parseFloat(productivityScale.getProductivityScale()) === 0;
   
   let allowZeroQtyFill = allowZeroQtyDueToInheritedZeroScale || currentActionScreenManager?.currentActionConfig?.allowConsumptionZeroQt === 1 ? true : false;
   let curConsumptions = screenStore?.mapConsumptions ? screenStore?.mapConsumptions : [];

   let hasErrors = false;
   for(let i = 0; i<curConsumptions.length;i++)
   {

      let quantity = parseFloat(curConsumptions[i]?.consumptionObj?.Quantity);
      if(!allowZeroQtyFill && quantity <= 0){
        curConsumptions[i].consumptionObj.hasQuantityError = true;
        hasErrors = true;
        
      }


      if(!hasErrors && curConsumptions[i]?.consumptionObj?.useConsLotAsFinalLotRef === 1){
        let newLotCode = curConsumptions[i]?.consumptionObj?.newLotCode;
        if(newLotCode){
          let selStatePop = {...productionOrderSelectionStore.productionOrderProduct};
          selStatePop.prodFinalLotCode = newLotCode;

          dispatchProductionOrderSelectionStore({
            type: "SET_PRODUCTION_ORDER_PRODUCT",
            payload: selStatePop,
          });
        }

        break;
      }
   }
   if(hasErrors){
    dispatchActionScreenAskBomConsumptionsStore({
      type: "SET_MAP_CONSUMPTIONS",
      payload: [...JSON.parse(JSON.stringify(curConsumptions))],
    });
    return;
   }

    if(isFillerMode){
      let storeResult = confirmFillerConsumptions();
      if(storeResult !== false){
        finishConfirmStoreResult(storeResult);
      }
    }else{
      let allowConsumptionRegardlessOfAvailableStock = currentActionConfig?.allowConsumptionRegardlessOfAvailableStock === 1 ? true : false;
      let storeResult = confirmConsumptions();
      if (storeResult !== false) {
        if (allowConsumptionRegardlessOfAvailableStock) {
          finishConfirmStoreResult(storeResult);
        } else {
          let currentMapConsumptions = screenStore.mapConsumptions;
          let preparedProductsFilterList:any = prepareProductsFilterList();
        
          stockManagementController()
            .getProductsStockAtLocation(
              preparedProductsFilterList,
              { lotTraceability: true }
            )
            .then((res) => {
              console.log("response: ", res);
              let stockResponse = res?.data?.response?.data;
              let qty = 0;
              let hasErrors = false;
              debugger;
              if (stockResponse) {
                for (let i = 0; i < stockResponse.length; i++) {
                  let resultingQty = 0;
                  let stockProduct = stockResponse[i];
                  if (stockProduct.stockResult) {
                    if (stockProduct.stockResult.length > 1) {
                      //throw error, returned more than expected stock results
                      //exact params passed should return only 1
                      hasErrors = true;
                      throw "error calcx, returned multiple results, some grouping might be missing";
                    }
    
                    resultingQty = stockProduct.stockResult[0].Quantity;
                  }
    
                  if (resultingQty <= 0) {
                    //show error
                    hasErrors = true;
                    currentMapConsumptions[
                      i
                    ].consumptionObj.showInsufficientQuantityAtLocationError =
                      true;
                    console.log("not enough qty");
                  } else {
                    //the current i, matches the local array map in positions.
                    if (
                      resultingQty <
                      parseFloat(
                        currentMapConsumptions[i].consumptionObj.Quantity
                      )
                    ) {
                      hasErrors = true;
                      console.log(
                        "not enough qty " +
                          resultingQty +
                          " < " +
                          currentMapConsumptions[i].consumptionObj.Quantity
                      );
                      currentMapConsumptions[
                        i
                      ].consumptionObj.showInsufficientQuantityAtLocationError =
                        true;
                    } else {
                      console.log("enough qty");
                    }
                  }
                }
                if (!hasErrors) {
                  finishConfirmStoreResult(storeResult);
                } else {
                  dispatchActionScreenAskBomConsumptionsStore({
                    type: "SET_MAP_CONSUMPTIONS",
                    payload: [...currentMapConsumptions],
                  });
                }
              } else {
                //throw error
              }
            })
            .catch((err) => {
              console.log("error: ", err);
            });
          //todo , ajax call check stock if errors show errors else props.callbackSuccessConfirm
        }
      }else{
        feedbackService.notifyToast(t('please.fill.all.fields.correctly'), "error");
      }
    }

  }
  const isWarehouseFieldEnabled = (key: string) => {
    let mapConsumptions = screenStore.mapConsumptions;

    let consumption = findConsumptionByKey(
      mapConsumptions,
      key
    );
    if (
      consumption?.consumptionObj?.Id_WarehouseLocation &&
      consumption.consumptionObj.Id_WarehouseLocation !== 0
    ) {
      return true;
    }
    return false;
  };

  const isLotFieldEnabled = (key: string) => {
    let mapConsumptions = screenStore.mapConsumptions;

    let consumption = findConsumptionByKey(
      mapConsumptions,
      key
    );
    if (
      consumption?.consumptionObj?.Id_Warehouse &&
      consumption.consumptionObj.Id_Warehouse !== 0
    ) {
      return true;
    }
    return false;
  };

  const validationStockLocation = (consumptionObj: any) => {

    let requireFillStockLocation = currentActionScreenManager?.currentActionConfig?.requireFillStockLocation == 1;

    let isWhLocDefined = false;
    let isWhDefined = false;
    let isLotDefined = false;

    let validation = {
      warehouseErrors: false,
      warehouseLocationErrors: false,
      lotErrors: false,
    };
    if (
      consumptionObj?.Id_WarehouseLocation &&
      consumptionObj?.Id_WarehouseLocation !== 0
    ) {
      isWhLocDefined = true;
    }
    if (consumptionObj?.Id_Warehouse && consumptionObj?.Id_Warehouse !== 0) {
      isWhDefined = true;
    }
    if (consumptionObj?.Id_Lot && consumptionObj?.Id_Lot !== 0) {
      if(consumptionObj?.Id_Lot === "new" && (!consumptionObj?.newLotCode || consumptionObj?.newLotCode === "")){
        isLotDefined = false;
      }else{
        isLotDefined = true;
      }
      
    }

    let isAtLeastOneDefined = false;
    if (isWhLocDefined || isWhDefined || isLotDefined) {
      isAtLeastOneDefined = true;
    }

    if (isAtLeastOneDefined) {
      if (!isWhLocDefined) {
        validation.warehouseLocationErrors = true;
      }
      if (!isWhDefined) {
        validation.warehouseErrors = true;
      }
      if (!isLotDefined) {
        validation.lotErrors = true;
      }
    }
    if(requireFillStockLocation && (!isWhLocDefined)){
      validation.warehouseLocationErrors = true;
      validation.warehouseErrors = true;
      validation.lotErrors = true;
    }

    return validation;
  };

  const getProperTitle = () => {

    if(currentActionScreenManager?.currentActionConfig?.generatedMovement === "WASTE"){
      return t('material.wastes');
    }
    return t("bom.consumptions");
  }

  const getProperSubtitle = () => {
    if(currentActionScreenManager?.currentActionConfig?.generatedMovement === "WASTE"){
      return (<><b>{t('wastes.list')}</b></>);
    }
    return (<><b>{t('list.consumptions')}</b></>);
  }

  const getProperIcon = () => {
    if(currentActionScreenManager?.currentActionConfig?.generatedMovement === "WASTE"){
      return(<><div className={styles.trashIcon}><DeleteIcon fontSize="medium"/></div></>);
    }
    return (<></>)
  }

  const getProperStyle = () => {
    if(currentActionScreenManager?.currentActionConfig?.generatedMovement === "WASTE"){
      return {backgroundColor:'rgb(84 68 42)'};
    }

    return {backgroundColor:'rgb(75, 75, 215)'};
  }

  const getShouldMultiplyByProductivityScale = () => {
    let shouldIgnoreMultiply = currentActionScreenManager?.currentActionConfig?.ignoreProductivityScaleMultiplyEnd === 1;
    return !shouldIgnoreMultiply;
  }

  const confirmFillerConsumptions = () => {
    let hasErrors = false;
    let hasErrorNotAllFilled = false;
    let mapFillerConsumptions = JSON.parse(JSON.stringify(screenStore.mapFillerConsumptions));
   
    const isRequiredAllFilled = true;
    let generatedMovement = currentActionScreenManager?.currentActionConfig?.generatedMovement;

    let allowZeroQtyDueToInheritedZeroScale = parseFloat(productivityScale.getProductivityScale()) === 0;

    let hasAtLeastOneConsumptionBecomingNegative = false;
    let hasAtLeastOneConsumptionFailedStockVerification = false;
    let arrayBom = getMapArrayFromBom();
    
    
    
    for(let i = 0; i<arrayBom.length; i++){
      let bomPcKey = buildKeyForChildProduct(arrayBom[i]);
      let requiredQuantity = getRequiredQuantity(i);//arrayBom[i].Quantity;
      let filledConsumptions = mapFillerConsumptions?.[bomPcKey] ? mapFillerConsumptions?.[bomPcKey] : [];
      let listedQuantity = 0;
      for(let j = 0; j<filledConsumptions.length; j++){
        listedQuantity += filledConsumptions[j].Quantity;
        //---
        if(currentActionScreenManager?.currentActionConfig?.verifyStockPerConsumption === 1){
          if(filledConsumptions?.[j]?._stockVerifyIdentifier){
            if(mapConsumptionLocationStockVerified?.[filledConsumptions?.[j]?._stockVerifyIdentifier] === undefined){
              hasAtLeastOneConsumptionFailedStockVerification = true;
              hasErrors = true;
            }else if(mapConsumptionLocationStockVerified?.[filledConsumptions?.[j]?._stockVerifyIdentifier]?.availableQuantityAfterConsumption < 0){
              if(!confirmedIgnoreBecommingNegative){
                hasErrors = true;
                hasAtLeastOneConsumptionBecomingNegative = true;
              }
              
            }
          
          }
        }
 
      }

      let allowSkipCheckQtyRequirement = allowZeroQtyDueToInheritedZeroScale && listedQuantity === 0;

      if(!allowSkipCheckQtyRequirement && isRequiredAllFilled && parseFloat(HxfNumberFormat().val(listedQuantity)) < parseFloat(HxfNumberFormat().val(requiredQuantity))){
        console.log("Not all products filled: listedQuantity " + listedQuantity + "  <  requiredQuantity " + requiredQuantity + " bomProduct: ",arrayBom[i]);
        //error
        hasErrors = true;
        hasErrorNotAllFilled = true;
      }
    }

    let keysFillerConsumptions = Object.keys(mapFillerConsumptions);
    for(let i = 0;i<keysFillerConsumptions.length; i++){
      if(generatedMovement){
        let consumptions = mapFillerConsumptions[keysFillerConsumptions[i]];
        if(consumptions && consumptions.length > 0){
          for(let j = 0; j<consumptions.length; j++){
            consumptions[j].generatedMovement = generatedMovement;
            
          }
        }
        mapFillerConsumptions[keysFillerConsumptions[i]] = consumptions;
      }
    }

    dispatchActionScreenAskBomConsumptionsStore({
      type: "SET_MAP_FILLER_CONSUMPTIONS",
      payload: mapFillerConsumptions,
    });

    if(!hasErrors){
      let returnObj:any = {mapFillerConsumptions:mapFillerConsumptions};
      //let shouldMultiplyByScale = getShouldMultiplyByProductivityScale();
      let shouldMultiplyByScale = currentActionScreenManager?.currentActionConfig?.ignoreProductivityScaleMultiplyEnd === 1;
      if(shouldMultiplyByScale){
        returnObj.postMultiplyAllConsumptionsBy = productivityScale.getProductivityScale();
      }
      return returnObj;
    }

    if(hasErrorNotAllFilled){
      feedbackService.notifyToast(t('not.all.products.were.filled'), "error");
     
      return false;
    }
    if(hasAtLeastOneConsumptionFailedStockVerification){
      feedbackService.notifyToast(t('please.verify.stock.of.all.consumptions'), "error");
      return false;
    }
    if(hasAtLeastOneConsumptionBecomingNegative && !confirmedIgnoreBecommingNegative){
      present({
        cssClass: "my-css",
        header: t("negative.stock.consumption"),
        message:
        t("consumption.negative.stock.confirm.sure"),
        buttons: [
          t("cancel"),
          {
            text: t("yes"),
            handler: (d:any) => {
              setConfirmedIgnoreBecommingNegative(true);

            },
          },
        ],
        onDidDismiss: (e:any) => {},
      });
      return false;
    }
    return false;
  }

  const confirmConsumptions = () => {
    let hasErrors = false;

    let returnObj:any = { mapConsumptions: screenStore.mapConsumptions };
    let shouldMultiplyByScale = currentActionScreenManager?.currentActionConfig?.ignoreProductivityScaleMultiplyEnd === 1;
    if(shouldMultiplyByScale){
      returnObj.postMultiplyAllConsumptionsBy = productivityScale.getProductivityScale();
    }
    
    let mapConsumptions = returnObj.mapConsumptions;
    for (let i = 0; i < mapConsumptions.length; i++) {
      let consumption = mapConsumptions[i];

      let consumptionQty = consumption.consumptionObj.Quantity ? consumption.consumptionObj.Quantity : 0;
      consumptionQty = parseFloat(consumptionQty);


      let stockLocationValidation = validationStockLocation(
        consumption.consumptionObj
      );
      if (
        consumptionQty > 0 && (
        stockLocationValidation.warehouseLocationErrors == true ||
        stockLocationValidation.warehouseErrors == true ||
        stockLocationValidation.lotErrors == true)
      ) {
        hasErrors = true;
      }
      consumption.consumptionObj = {
        ...consumption.consumptionObj,
        ...stockLocationValidation,
      };

      let generatedMovement = currentActionScreenManager?.currentActionConfig?.generatedMovement;
      if(generatedMovement && consumption?.consumptionObj){
        consumption.consumptionObj.generatedMovement = generatedMovement;
      }
      
      mapConsumptions[i] = consumption;
    }

    dispatchActionScreenAskBomConsumptionsStore({
      type: "SET_MAP_CONSUMPTIONS",
      payload: [...mapConsumptions],
    });
    returnObj = { mapConsumptions: mapConsumptions }; //updates return obj

    if (hasErrors) {
      return false;
    }

    return returnObj;
  };

  const prepareProductsFilterList = () => {
    let currentMapConsumptions = screenStore.mapConsumptions;

    let preparedProductsFilterList = [];
    for (let i = 0; i < currentMapConsumptions.length; i++) {
      let consumption = currentMapConsumptions[i];
      let prepareStockMovementProductParameterizedVariableValues = consumption.consumptionObj?.arrayProductParameterizedVariables ? consumption.consumptionObj?.arrayProductParameterizedVariables : [];

      let stockLocation = null;

      if (
        consumption?.consumptionObj.Id_WarehouseLocation &&
        consumption?.consumptionObj?.Id_WarehouseLocation !== 0
      ) {
        stockLocation = {
          Id_WarehouseLocation: consumption.consumptionObj.Id_WarehouseLocation,
          Id_Warehouse: consumption.consumptionObj.Id_Warehouse,
          Id_Lot: consumption.consumptionObj.Id_Lot,
        };
      }

      let newElement = {
        key: consumption.key,
        Id_Product: consumption.consumptionObj.Id_Product,
        stockMovement_productParameterizedVariables: prepareStockMovementProductParameterizedVariableValues,
        exactProductParameterizedVariables: true,
        exactProductStockLocation: true,
        stockLocation: {},
      };
      if (stockLocation !== null) {
        newElement = { ...newElement, stockLocation: { ...stockLocation } };
      }
      preparedProductsFilterList.push(newElement);
    }

    return preparedProductsFilterList;
  };


  useEffect(() => {
    if(prevTriggerOnFinishScan !== triggerOnFinishScan && triggerOnFinishScan){
      let result:any = triggerOnFinishScan;
      setTriggerOnFinishScan(null);
      console.log("RESULT: ", result);
     
      let format = result.resultFormat;
      let resultScan = result.resultScan;
      let barcodeSettings = triggerFinishScanBarcodeSettings.current;

      let pattern = format.pattern;

      let scannedWithQrcode = false;
      let scannedWithBarcode = false;
      let delimiter = null;

      let currentAllowedScanFormats = barcodeSettings.allowedScanFormats;

      if(ALLOW_BARCODESCANNER_TO_ALSO_SCAN_QRCODES){
        if(format.type === "barcode39" || format.type === "barcode128"){
        
            for(let i = 0; i<currentAllowedScanFormats.length; i++){
              if(!currentAllowedScanFormats[i]?._skipMatchFindDelimiterProcessing && currentAllowedScanFormats[i].pattern === pattern){
                  //match found
                  let realType = currentAllowedScanFormats[i]?.type;
                
                  //SWAP type and process as if it was scanned with qrcode (in case it was qrcode pattern the one scanned)
                  format.type = realType;
                
              }
            }
          
        }
      }
      if (format.type === "barcode39") {
        delimiter = ScannablesService().hxfBarcode39Delimiter;
        scannedWithBarcode= true;
      }

      if (format.type === "barcode128") {
        delimiter = ScannablesService().hxfBarcode128Delimiter;
        scannedWithBarcode= true;
      }

      if (format.type === "qrcode") {
        delimiter = ScannablesService().hxfQrcodeDelimiter;
        scannedWithQrcode= true;
      }

    
    
      let splittedPattern = pattern.split(delimiter);
     
      let indexThatIdentifiesTheProductId:any = -1;
      let indexThatIdentifiesTheLotId = -1;
   
      let indexThatIdentifiesTheProductionRecord = -1;
      for (let i = 0; i < splittedPattern.length; i++) {
     
        if (splittedPattern[i] === "[product.id]") {
          indexThatIdentifiesTheProductId = i;        
        }

        if (splittedPattern[i] === "[lot.id]") {
          indexThatIdentifiesTheLotId = i;
         
        }
      }
      
      let isIdentifyingByProductAndLot = indexThatIdentifiesTheLotId !== -1 && indexThatIdentifiesTheProductId !== -1;

      if(isIdentifyingByProductAndLot){
        
        //identified with product id and lot id
        let splittedResult = resultScan.split(delimiter);
        let idLot = splittedResult[indexThatIdentifiesTheLotId];
        let idProduct = splittedResult[indexThatIdentifiesTheProductId];

        let arrayProductParameterizedVariables:any = []; //this type of scan does not support PPVVS so set as empty
        

       
        processScanSelectionByProductAndLot(idLot, idProduct);


      }


    }
  },[triggerOnFinishScan]);

  useEffect(() => {

    
    if(autoConfirmAfterDispatchingConsumptions.current === true){
      
      console.log("triggering autoconfirm");
      autoConfirmAfterDispatchingConsumptions.current = false;
    
      clickConfirm();// eslint-disable-line
    }
  },[screenStore]);// eslint-disable-line

  useEffect(() => {
    if (!didMount) {

      let skipIfNoLogisticLocSelected = currentActionScreenManager?.currentActionConfig?.skipIfNoLogisticLocSelected === 1;
      let skipIfScaleZero = currentActionScreenManager?.currentActionConfig?.skipIfScaleZero;
      
      let latestActionLogisticsLocationDefined = productionOrderSelectionStore?.productionOrderProduct?.latestActionLogisticsLocationDefined;
      
      let currentScale = parseFloat(productivityScale.getProductivityScale());
      let shouldAutoSkip = (currentScale === 0 && skipIfScaleZero) || (skipIfNoLogisticLocSelected && latestActionLogisticsLocationDefined === null);

      
      let currentMapConsumptions = screenStore.mapConsumptions;
      
      let currentActionConfig = currentActionScreenManager?.currentActionConfig;

      let shouldIgnoreProductivityScale = currentActionScreenManager?.currentActionConfig?.ignoreProductivityScaleMultiplyEnd === 1;

      let isSilentModeOn = currentActionConfig?.silentMode === 1;
      autoConfirmAfterDispatchingConsumptions.current = isSilentModeOn;

      if (currentMapConsumptions.length === 0) {

        
        //if didnt load to the screenstate from the consumptions map before

        let loadingBaseConsumptionsData = getMapArrayFromBom();
        let newConsumptionsMap = [];
        for (let i = 0; i < loadingBaseConsumptionsData.length; i++) {

          let key = loadingBaseConsumptionsData[i]["key"];
          let idProduct = loadingBaseConsumptionsData[i]["Id_ProductChild"];
          let idProductComponent = loadingBaseConsumptionsData[i]["Id_ProductComponent"];
          let productComponentsParameterizedVariables =
            loadingBaseConsumptionsData[i][
              "productComponent_ParameterizedVariables"
            ]
              ? loadingBaseConsumptionsData[i][
                  "productComponent_ParameterizedVariables"
                ]
              : null;
          let productParameterizedVariables = loadingBaseConsumptionsData[i][
            "productParameterizedVariables"
          ]
            ? loadingBaseConsumptionsData[i]["productParameterizedVariables"]
            : null;
       
          let quantity = parseFloat(loadingBaseConsumptionsData[i]["Quantity"]);
          let useConsLotAsFinalLotRef = loadingBaseConsumptionsData?.[i]?.productComponentSettings?.useConsLotAsFinalLotRef;

          let consumeFromSelectedMachine = loadingBaseConsumptionsData?.[i]?.["consumeFromSelectedMachine"] && parseInt(loadingBaseConsumptionsData[i]["consumeFromSelectedMachine"]) === 1 ? 1 : 0;
         
          //check if product qty was mentioned previously
          //to properly calculate the consumption to show

          if (productionOrderSelectionStore?.production?.persistedStateResult) {
            let persistedStateResultObj = JSON.parse(
              productionOrderSelectionStore.production.persistedStateResult
            );
            if (
              persistedStateResultObj["PRODUCE_PRODUCT_QUANTITY"]?.quantity > 0
            ) {
              quantity =
                quantity *
                persistedStateResultObj["PRODUCE_PRODUCT_QUANTITY"]?.quantity;
            }
          }

          
          // check if defined product qty on the current operation
          if(shouldIgnoreProductivityScale){
            quantity = quantity*1;
          }else if (props?.productionOperationHandler) {
            let currentPostingObject =  props.productionOperationHandler.getCurrentPostingProductionDataObject();

            let isQtProduceDefined = currentPostingObject?.PRODUCE_PRODUCT_QUANTITY?.quantity !== null && currentPostingObject?.PRODUCE_PRODUCT_QUANTITY?.quantity !== undefined;
            if (isQtProduceDefined) {
              let postingQty =
                currentPostingObject?.PRODUCE_PRODUCT_QUANTITY?.quantity;
              if (!postingQty) {
                postingQty = 0;
              }
              quantity = quantity * postingQty;
            
            } else {
              //calculate from scape productivity

              quantity = quantity * productivityScale.getProductivityScale();
            }
          }

        
          let currentActionConfig = currentActionScreenManager?.currentActionConfig;

          if (typeof currentActionConfig === "string") {
            currentActionConfig = JSON.parse(currentActionConfig);
          }

          let whLocCode = currentActionConfig?.temp_warehouseLocation_code ? currentActionConfig?.temp_warehouseLocation_code : "";
          let whLocName = currentActionConfig?.temp_warehouseLocation_name ? currentActionConfig?.temp_warehouseLocation_name : "";
          
          let whLocLabel = whLocCode ? "(" + whLocCode + ") " + whLocName : null;

          let whCode = currentActionConfig?.temp_warehouse_code ? currentActionConfig?.temp_warehouse_code : "";
          let whName = currentActionConfig?.temp_warehouse_name ? currentActionConfig?.temp_warehouse_name : "";
          let whLabel = whCode ? "(" + whCode + ") " + whName : null;


          let consumption = {
            key: buildKeyForChildProduct(loadingBaseConsumptionsData[i]),
            consumptionObj: {
              Id_ProductComponent:idProductComponent,
              Id_Product: idProduct,
              productComponent_ParameterizedVariables:
                productComponentsParameterizedVariables,
              productParameterizedVariables: productParameterizedVariables,
              arrayProductParameterizedVariables:loadingBaseConsumptionsData[i].arrayProductParameterizedVariables,
              Quantity: quantity,
              Id_WarehouseLocation:currentActionConfig?.Id_WarehouseLocation ? currentActionConfig.Id_WarehouseLocation : null,
              Id_Warehouse:currentActionConfig?.Id_Warehouse ? currentActionConfig.Id_Warehouse : null,
              Id_Lot:currentActionConfig?.Id_Lot ? currentActionConfig.Id_Lot : null,
              consumeFromSelectedMachine:consumeFromSelectedMachine,
              useConsLotAsFinalLotRef:useConsLotAsFinalLotRef,
              temp_lot_code:currentActionConfig?.temp_lot_code,
              temp_lot_name:currentActionConfig.temp_lot_name,
              temp_lotLabel:currentActionConfig?.temp_lot_code,
              temp_warehouseLabel:whLabel,
              temp_warehouseLocationLabel:whLocLabel,
            },
          };
          newConsumptionsMap.push(consumption);
          
        }
     

        let cleanPayload = JSON.parse(JSON.stringify([...newConsumptionsMap]));
        console.log("dispatching");
        dispatchActionScreenAskBomConsumptionsStore({
          type: "SET_MAP_CONSUMPTIONS",
          payload: cleanPayload,
        });
      }else{
        if(isSilentModeOn){
          console.log("nothing to dispatch, skipping");
          shouldAutoSkip = true;
        }
        
      }

      if(shouldAutoSkip){
        clickConfirm();
      }

      setDidMount(true);
    }
  }, [
    didMount,
    props.productionOperationHandler,
    getMapArrayFromBom,
    screenStore.mapConsumptions,
    productionOrderSelectionStore,
    productivityScale,
    currentActionScreenManager
  ]);

  const getWhLocConsumptionListJsonOptions = (bomChild:any) => {
    let key = buildKeyForChildProduct(bomChild);
    let newMapConsumptions = screenStore.mapConsumptions;

    let consumption = null;
    consumption = findConsumptionByKey(
      newMapConsumptions,
      key
    );
    if(consumption !== null){

      let opts:any = {};
      let idWhLoc = consumption?.consumptionObj?.Id_WarehouseLocation;
      if(idWhLoc){
        opts.Id_WarehouseLocation = idWhLoc;
      }
      return opts;
    }
    return {};
  }
  const buildKeyForChildProduct = (productComponent:any) => {
    
    let idProduct = productComponent.Id_ProductChild;
    let arrPpvs = productComponent?.arrayProductParameterizedVariables;
    if(!arrPpvs){
      arrPpvs = [];
    }
    let keyStr = idProduct;

    for(let i = 0; i<arrPpvs.length; i++){
      let idProductParameterizedVariable = arrPpvs[i].Id_Product_ParameterizedVariable;
      let value = arrPpvs[i].Value;
      keyStr += "_idppv_" + idProductParameterizedVariable + "_val_" + value;
    }
    return keyStr.toString();
  }


  const updateLocationConsumption = (bomChild:any, updatingLocationData:any) => {
    let key = buildKeyForChildProduct(bomChild);
    let newLotValue = updatingLocationData?.newLotData?.lotValue;

    let newMapConsumptions = screenStore.mapConsumptions;
    let consumption:any = null;
    consumption = findConsumptionByKey(
      newMapConsumptions,
      key
    );
    let exists = true;

    if (consumption === null) {
      exists = false;
      consumption = {
        key: key,
        consumptionObj: {
          Id_Product: 0,
          Quantity: 0,
          Id_WarehouseLocation: 0,
          Id_Warehouse: 0,
          Id_Lot: 0,
          temp_warehouseLocationLabel: "",
          temp_warehouseLabel: "",
          temp_lotLabel: "",
          newLotCode:"",
        },
      };

      consumption.consumptionObj.Id_Product = bomChild.Id_ProductChild;
      consumption.consumptionObj.Quantity = consumption?.consumptionObj?.Quantity ? consumption?.consumptionObj?.Quantity : 0; // bomChild.Quantity;
    }
    consumption.consumptionObj.lotErrors = false;
    if(updatingLocationData?.newLotData !== undefined){
      consumption.consumptionObj.Id_Lot = "new";
      consumption.consumptionObj.newLotCode = newLotValue;
    }

    if(updatingLocationData?.newWhData !== undefined){
      consumption.consumptionObj.Id_Warehouse = updatingLocationData?.newWhData.Id;

      let whName = updatingLocationData?.newWhData.name;
      let whCode = updatingLocationData?.newWhData.code;
      consumption.consumptionObj.temp_warehouseLabel = whCode ? "(" + whCode + ") " + whName : null;
    }
    if(updatingLocationData?.newWhLocData !== undefined){
      consumption.consumptionObj.Id_WarehouseLocation = updatingLocationData?.newWhLocData.Id;

      let whLocName = updatingLocationData?.newWhLocData.name;
      let whLocCode = updatingLocationData?.newWhLocData.code;
      consumption.consumptionObj.temp_warehouseLocationLabel = whLocCode ? "(" + whLocCode + ") " + whLocName : null;
    }

    consumption.consumptionObj.warehouseErrors = false;
    consumption.consumptionObj.showInsufficientQuantityAtLocationError =
      false;
    if (!exists) {
      newMapConsumptions.push(consumption);
    } else {
      newMapConsumptions = replaceConsumptionObjByKey(
          newMapConsumptions,
          key,
          consumption.consumptionObj
        );
    }

    dispatchActionScreenAskBomConsumptionsStore({
      type: "SET_MAP_CONSUMPTIONS",
      payload: [...newMapConsumptions],
    });
  }
  const updateLotName = (bomChild:any,lotValue:any) => {
    //DERPECATED
    let key = buildKeyForChildProduct(bomChild);
    let newLotValue = lotValue;

    let newMapConsumptions = screenStore.mapConsumptions;
    let consumption = null;
    consumption = findConsumptionByKey(
      newMapConsumptions,
      key
    );
    let exists = true;

    if (consumption === null) {
      exists = false;
      consumption = {
        key: key,
        consumptionObj: {
          Id_Product: 0,
          Quantity: 0,
          Id_WarehouseLocation: 0,
          Id_Warehouse: 0,
          Id_Lot: 0,
          temp_warehouseLocationLabel: "",
          temp_warehouseLabel: "",
          temp_lotLabel: "",
          newLotCode:"",
        },
      };

      consumption.consumptionObj.Id_Product = bomChild.Id_ProductChild;
      consumption.consumptionObj.Quantity = bomChild.Quantity;
    }
    consumption.consumptionObj.lotErrors = false;

    consumption.consumptionObj.Id_Lot = "new";
    consumption.consumptionObj.newLotCode = newLotValue;
    consumption.consumptionObj.warehouseErrors = false;
    consumption.consumptionObj.showInsufficientQuantityAtLocationError =
      false;
    if (!exists) {
      newMapConsumptions.push(consumption);
    } else {
      newMapConsumptions = replaceConsumptionObjByKey(
          newMapConsumptions,
          key,
          consumption.consumptionObj
        );
    }

    dispatchActionScreenAskBomConsumptionsStore({
      type: "SET_MAP_CONSUMPTIONS",
      payload: [...newMapConsumptions],
    });
  }

  const getFillerModeStockLocations = (indexBoMChild:any) => {
    let arrayProductBom = getMapArrayFromBom();
    let bomChild = arrayProductBom[indexBoMChild];
 
    let childKey = buildKeyForChildProduct(bomChild);
    let currentMapConsumptions = screenStore.mapFillerConsumptions;

    let listConsumptions = currentMapConsumptions?.[childKey] ? currentMapConsumptions?.[childKey] : [];

    return (
    <>
      <div className={styles.addBtnContainer}>
          <IonButton
              data-btn-define-cons-location-idx={indexBoMChild}
              onClick={() => {
                setAddingFillConsumption({
                  Quantity:bomChild?.Quantity,
                  productKey:childKey,
                  Id_Product:bomChild.Id_ProductChild,
                  arrayProductParameterizedVariables:bomChild.arrayProductParameterizedVariables,
                  productName:bomChild.childProduct_name,
                  productCode:bomChild.childProduct_code,
                  _isDefiningNewStockQty:bomChild?.askUpdateConsLocStockQty === 1,
                  _step:"STOCK_LOCATION"
                });
              }}
          >
              <IonIcon slot="icon-only" size="large" icon={add} />
          </IonButton>
      </div>
      <div>
      {currentActionScreenManager?.currentActionConfig?.existingLots === 1 && (
                      <>
          <HxfExistingLotsButton 
            productName={bomChild.childProduct_name} 
            Id_Product={bomChild.Id_ProductChild}
            arrayProductParameterizedVariables={bomChild?.arrayProductParameterizedVariables ? bomChild.arrayProductParameterizedVariables : []}
            onLotSelection={(data:IExistLotResultLocation) => {
              if(!data?.Id_Lot){
                return;
              }
              let updatingLocationData:any = {};
              if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillLot === 1){
                updatingLocationData.newLotData = { //for lots we only need the lot code directly as it is calculated in the backend
                  Id:data.Id_Lot,
                  lotValue:data.lotCode
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillWh === 1){
                updatingLocationData.newWhData = { 
                  Id:data.Id_Warehouse,
                  code:data.warehouseCode,
                  name:data.warehouseName
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillWhLoc === 1){
                updatingLocationData.newWhLocData = { 
                  Id:data.Id_WarehouseLocation,
                  code:data.warehouseLocationCode,
                  name:data.warehouseLocationName
                };
              }
              //updateLocationConsumption(bomChild,updatingLocationData);
            
              if(!updatingLocationData?.newLotData?.Id){
                console.log("no lot selected, not filling consumption, check 'on select fill lots' action consumption");
              }
            
              setAddingFillConsumption({
                Quantity:bomChild?.Quantity,
                productKey:childKey,
                Id_Product:bomChild.Id_ProductChild,
                arrayProductParameterizedVariables:bomChild.arrayProductParameterizedVariables,
                productName:bomChild.childProduct_name,
                productCode:bomChild.childProduct_code,
                Id_Lot:updatingLocationData?.newLotData?.Id,
                lotData:{code:data?.lotCode,name:data?.lotCode},
                Id_Warehouse:updatingLocationData?.newWhData.Id,
                warehouseData:{code:data?.warehouseCode,name:data?.warehouseName},
                Id_WarehouseLocation:updatingLocationData?.newWhLocData.Id,
                warehouseLocationData:{code:data?.warehouseLocationCode,name:data?.warehouseLocationName},
                _isDefiningNewStockQty:bomChild?.askUpdateConsLocStockQty === 1,
                _step:"QUANTITY_SET"
              });
            }}
            />
          </>
          )
        }

        {currentActionScreenManager?.currentActionConfig?.stagedLotSuggestions === 1 && (
          <>
          <HxfStagedLotsButton 
            stagedArrayMaterialComponentsData={getStagedMaterial()}
            bomChild={{Id_ProductChild:bomChild.Id_ProductChild,childProduct_name:bomChild.childProduct_name,arrayProductParameterizedVariables: bomChild?.arrayProductParameterizedVariables ? bomChild.arrayProductParameterizedVariables : []}}
            onLotSelection={(data:IExistLotResultLocation) => {
              
              if(!data?.Id_Lot){
                return;
              }


              let updatingLocationData:any = {};
              if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillLot === 1){
                updatingLocationData.newLotData = { //for lots we only need the lot code directly as it is calculated in the backend
                  lotValue:data.lotCode,
                  Id:data?.Id_Lot,
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillWh === 1){
                updatingLocationData.newWhData = { 
                  Id:data?.Id_Warehouse,
                  code:data?.warehouseCode,
                  name:data?.warehouseName
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillWhLoc === 1){
                updatingLocationData.newWhLocData = { 
                  Id:data?.Id_WarehouseLocation,
                  code:data?.warehouseCode,
                  name:data?.warehouseName
                };
              }
              
              setAddingFillConsumption({
                Quantity:bomChild?.Quantity,
                productKey:childKey,
                Id_Product:bomChild.Id_ProductChild,
                arrayProductParameterizedVariables:bomChild.arrayProductParameterizedVariables,
                productName:bomChild.childProduct_name,
                productCode:bomChild.childProduct_code,
                Id_Lot:updatingLocationData?.newLotData?.Id,
                lotData:{code:data?.lotCode,name:data?.lotCode},
                Id_Warehouse:updatingLocationData?.newWhData.Id,
                warehouseData:{code:data?.warehouseCode,name:data?.warehouseName},
                Id_WarehouseLocation:updatingLocationData?.newWhLocData.Id,
                warehouseLocationData:{code:data?.warehouseLocationCode,name:data?.warehouseLocationName},
                _isDefiningNewStockQty:bomChild?.askUpdateConsLocStockQty === 1,
                _step:"QUANTITY_SET"
              });
            }}
          />
          </>)
        }
      </div>


      {listConsumptions.map((objCons:any, indexCons:any) => (
        <div key={"subcons_" + indexBoMChild + "_" + indexCons} className={`${styles.consumptionLine} ${checkIfWaitingConsumptionLineIsVerifyingStock(objCons) || checkIfFailedVerifyConsumptionLine(objCons) ? styles.loadingConsumptionLine : ""} ${!checkIfWaitingConsumptionLineIsVerifyingStock(objCons) && willConsumptionBecomeNegative(objCons) ? styles.consumptionLineWillBecomeNegative : ""}`}>
          <div>

            {checkIfFailedVerifyConsumptionLine(objCons) ? (
              <>
              <div>
              <IonButton
                color="warning"
                onClick={() => {
                  //clear current verification result
             
                  let newMapConsLocStockVerify = {...mapConsumptionLocationStockVerified};
                  delete newMapConsLocStockVerify?.[objCons?._stockVerifyIdentifier];
                  setMapConsumptionLocationStockVerified(newMapConsLocStockVerify);
                  verifyStock(objCons);
                
                }}
              >
                
                {t('verify.stock')}
              </IonButton>
              </div>
              <div>
              <small>{t('stock.verification.failed.try.again')}</small>
              </div>
              </>
            ): (
              <>
              {checkIfWaitingConsumptionLineIsVerifyingStock(objCons) ? (
                <div style={{marginTop:10,marginBottom:10}}><LoadingSpinnerImg marginTop={0} size={30}/></div>
              ) : (<>
              <IonButton
                color="danger"
                onClick={() => {
  
                  present({
                    cssClass: "my-css",
                    header: t("consumption.cancellation"),
                    message:
                    t("consumption.cancel.confirm.sure"),
                    buttons: [
                      t("cancel"),
                      {
                        text: t("yes"),
                        handler: (d:any) => {
                          let currentMapConsumptions = screenStore.mapFillerConsumptions;
                  
                          let listConsumptions = currentMapConsumptions?.[childKey] ? currentMapConsumptions?.[childKey] : [];
          
                          listConsumptions.splice(indexCons, 1);
                          currentMapConsumptions[childKey] = listConsumptions;
                          dispatchActionScreenAskBomConsumptionsStore({
                            type: "SET_MAP_FILLER_CONSUMPTIONS",
                            payload: JSON.parse(JSON.stringify(currentMapConsumptions)),
                          });
          
                        },
                      },
                    ],
                    onDidDismiss: (e:any) => {},
                  });
                }}
            >
                <IonIcon slot="icon-only" size="large" icon={remove} />
            </IonButton>
              </>)}
              </>
            )}

          </div>
          {objCons?.lotData ? (
            <>
              <div className={styles.smallLabel}><b>{t('warehouse')}:</b></div>
              <div>{objCons.warehouseData.code}</div>
              <div className={styles.smallLabel}><b>{t('lot')}:</b></div>
              <div>{objCons.lotData.code}</div> 
            </>
          ) : (<>{t('shopfloor')}</>)}      
          {bomChild.askUpdateConsLocStockQty === 1 ? (
            <>
             <div className={styles.smallLabel}><b>{t('stock.in.qty.short')}:</b></div>
             <div className={styles.addedQty}>{objCons.Quantity}</div>
            </>
          ): (
            <>
              <div className={styles.smallLabel}><b>{t('quantity')}:</b></div>
              <div className={`${styles.addedQty} ${willConsumptionBecomeNegative(objCons) ? styles.addedQtyError : ""}`}>+{objCons.Quantity}</div>
            </>
          )}

          {willConsumptionBecomeNegative(objCons) && (
            <div>
              <b>{t('attention.stock.become.negative')}</b>
            </div>
          )}
        </div>
      ))}
    </>
    )
  }
  const getStockLocationElement = (indexBoMChild: number) => {
    let arrayProductBom = getMapArrayFromBom();
    let bomChild = arrayProductBom[indexBoMChild];
    let childKey = buildKeyForChildProduct(bomChild);
    let currentActionConfig = currentActionScreenManager?.currentActionConfig;

    if (typeof currentActionConfig === "string") {
      currentActionConfig = JSON.parse(currentActionConfig);
    }
    let allowManualStockLocationSelection = false;

    let allowChangeWarehouseLocation = false;
    let allowChangeWarehouse = false;
    let allowChangeLot = false;
 
    //follow documentation for this action
    /*
        if user allowManualStockLocationSelection, allows selecting anywhere in the company where
        the stock is beeing taken from. If not allowManualStockLocationSelection then it selects from the configured
        wh location , wh and lot (if none of those is set then it takes from the default shopfloor location)

        If wh Location is set and ! allowManualStockLocationSelection, it doesnt allow changing wh location but allows other 2
        same logic if whlocation and wh is set. Allows only lot changing
        */
   
    if (currentActionConfig?.allowManualStockLocationSelection) {
      allowManualStockLocationSelection = currentActionConfig?.allowManualStockLocationSelection;
      allowChangeWarehouseLocation = true;
      allowChangeWarehouse = true;
      allowChangeLot = true;
    }

    if (!currentActionConfig?.allowManualStockLocationSelection) {
      /*if (
        currentActionConfig?.Id_WarehouseLocation &&
        currentActionConfig?.Id_WarehouseLocation !== 0
      ) {
        allowChangeWarehouseLocation = false;
        allowChangeWarehouse = true;
        allowChangeLot = true;
      }*/

      if (
        currentActionConfig?.allowManualLotSet
      ) {
   
        allowChangeLot = true;
      }
    }

    let idWarehouseLocation = currentActionConfig?.Id_WarehouseLocation
      ? currentActionConfig?.Id_WarehouseLocation
      : 0;
    let idWarehouse = currentActionConfig?.Id_Warehouse
      ? currentActionConfig?.Id_Warehouse
      : 0;
    let idLot = currentActionConfig?.Id_Lot ? currentActionConfig?.Id_Lot : 0;
   
    let currentMapConsumptions = screenStore.mapConsumptions;

    let consumption = null;
    consumption = findConsumptionByKey(
      currentMapConsumptions,
      childKey
    );
 
  
    return (
      <>
        <div key={"rerenderListKey_" + rerenderListKey}>
          {askStagedLotSelection && (
            <StagedLotsPopup
            topBar={{label:askStagedLotSelection?.productName}}
            selectableLots={askStagedLotSelection?.locationsQuantity}
             onClose={() => {
              setAskStagedLotSelection(null);
             }}
             onConfirm={(result:any) => {
            
              let selectedLot = result?.selectedLot;
              if(!selectedLot){
                return;
              }

             let updatingLocationData:any = {};
              if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillLot === 1){
                updatingLocationData.newLotData = { //for lots we only need the lot code directly as it is calculated in the backend
                  lotValue:selectedLot.lotData.code
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillWh === 1){
                updatingLocationData.newWhData = { 
                  Id:selectedLot.Id_Warehouse,
                  code:selectedLot.warehouseData.code,
                  name:selectedLot.warehouseData.name
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillWhLoc === 1){
                updatingLocationData.newWhLocData = { 
                  Id:selectedLot.Id_WarehouseLocation,
                  code:selectedLot.warehouseLocationData.code,
                  name:selectedLot.warehouseLocationData.name
                };
              }
              //updateLotName(askStagedLotSelection.bomChild,selectedLot.lotData.code);
              updateLocationConsumption(askStagedLotSelection.bomChild,updatingLocationData);
              setAskStagedLotSelection(null);
             }}
            />
          )}
          {/*askExistingLotSelection && (
            <ExistingLotsPopup
            topBar={{label:askExistingLotSelection?.productName}}
            selectableLots={askExistingLotSelection?.locationsQuantity}
             onClose={() => {
              setAskExistingLotSelection(null);
             }}
             onConfirm={(result:any) => {
              let selectedLot = result?.selectedLot;
              if(!selectedLot){
                return;
              }
              let updatingLocationData:any = {};
              if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillLot === 1){
                updatingLocationData.newLotData = { //for lots we only need the lot code directly as it is calculated in the backend
                  lotValue:selectedLot.lotData.code
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillWh === 1){
                updatingLocationData.newWhData = { 
                  Id:selectedLot.Id_Warehouse,
                  code:selectedLot.warehouseData.code,
                  name:selectedLot.warehouseData.name
                };
              }
              if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillWhLoc === 1){
                updatingLocationData.newWhLocData = { 
                  Id:selectedLot.Id_WarehouseLocation,
                  code:selectedLot.warehouseLocationData.code,
                  name:selectedLot.warehouseLocationData.name
                };
              }
              updateLocationConsumption(askExistingLotSelection.bomChild,updatingLocationData);
              //updateLotName(askExistingLotSelection.bomChild,selectedLot.lotData.code);
              setAskExistingLotSelection(null);
             }}
            />
          )*/}
          {!allowManualStockLocationSelection && idWarehouseLocation === 0 && idWarehouse === 0 && idLot === 0 ? (
            <div>{t("default.shopfloor")}</div>
          ) : (
            <div>
              {allowManualStockLocationSelection ||
              allowChangeWarehouseLocation ? (
                <div className={styles.selectorElem}>
                  <HxfSelectorField
                    error={
                      consumption?.consumptionObj?.warehouseLocationErrors ===
                      true
                    }
                    onChange={(evt, val) => {
                      let key = buildKeyForChildProduct(bomChild);
                      if (val === null) {
                        let currentMapConsumptions =
                          screenStore.mapConsumptions;

                        let consumption = null;
                        consumption = findConsumptionByKey(
                          currentMapConsumptions,
                          key
                        );
                        if (consumption !== null) {
                          consumption.consumptionObj.Id_WarehouseLocation = 0;
                          consumption.consumptionObj.warehouseLocationErrors =
                            false;
                          consumption.consumptionObj.Id_Warehouse = 0;
                          consumption.consumptionObj.warehouseErrors = false;
                          consumption.consumptionObj.Id_Lot = 0;
                          consumption.consumptionObj.lotErrors = false;
                          consumption.consumptionObj.showInsufficientQuantityAtLocationError =
                            false;
                        }

                        currentMapConsumptions = replaceConsumptionObjByKey(
                            currentMapConsumptions,
                            key,
                            consumption.consumptionObj
                          );
                        dispatchActionScreenAskBomConsumptionsStore({
                          type: "SET_MAP_CONSUMPTIONS",
                          payload: [...currentMapConsumptions],
                        });

                        setWarehouseSearchFilters({});
                      } else {
                        let targetLabel = val.label;
                        let targetValue = val.value;

                        let newMapConsumptions = screenStore.mapConsumptions;

                        let consumption = null;
                        consumption = findConsumptionByKey(
                          newMapConsumptions,
                          key
                        );
                        let exists = true;

                        if (consumption === null) {
                          exists = false;
                          consumption = {
                            key: key,
                            consumptionObj: {
                              Id_Product: 0,
                              Quantity: 0,
                              Id_WarehouseLocation: 0,
                              Id_Warehouse: 0,
                              Id_Lot: 0,
                              temp_warehouseLocationLabel: "",
                              temp_warehouseLabel: "",
                              temp_lotLabel: "",
                            },
                          };
                        }
                 
                        let code = val?.fetchedData?.code ? val?.fetchedData?.code : "";
                        let name = val?.fetchedData?.name ? val?.fetchedData?.name : "";

                        if(val?.fetchedData?.code){
                          targetLabel = "(" + code + ") " + name;
                        }

                        consumption.consumptionObj.Id_Product =
                          bomChild.Id_ProductChild;

                        consumption.consumptionObj.Quantity = consumption?.consumptionObj?.Quantity ? consumption.consumptionObj.Quantity : 0;//bomChild.Quantity;
                        consumption.consumptionObj.Id_WarehouseLocation =
                          targetValue;
                        consumption.consumptionObj.temp_warehouseLocationLabel =
                          targetLabel;
                        consumption.consumptionObj.lotErrors = false;
                        consumption.consumptionObj.showInsufficientQuantityAtLocationError =
                          false;

                        setWarehouseSearchFilters({
                          Id_WarehouseLocation: targetValue,
                        });

                        if (!exists) {
                          newMapConsumptions.push(consumption);
                        } else {
                          newMapConsumptions = replaceConsumptionObjByKey(
                              newMapConsumptions,
                              key,
                              consumption.consumptionObj
                            );
                        }

                        dispatchActionScreenAskBomConsumptionsStore({
                          type: "SET_MAP_CONSUMPTIONS",
                          payload: [...newMapConsumptions],
                        });

                        forceRerenderView();
                      }
                    }}
                    value={getWarehouseLocationConsumptionField(
                      buildKeyForChildProduct(bomChild)
                    )}
                    listJsonFunction={
                      warehouseLocationsController()
                        .getWarehouseLocationsListJson
                    }
                    uniqueId={"whLoc_cons_tgt_stock_" + bomChild["key"]}
                    labelPlaceholder={t("warehouselocation")}
                  />
                  
                </div>
              ) : (
                <div>
                  <b>{t("warehouselocation")}: </b> (
                  {currentActionConfig?.temp_warehouseLocation_code}){" "}
                  {currentActionConfig?.temp_warehouseLocation_name}
                </div>
              )}
              {allowManualStockLocationSelection || allowChangeWarehouse ? (
                <div className={styles.selectorElem}>
                  <HxfSelectorField
                    disabled={!isWarehouseFieldEnabled(buildKeyForChildProduct(bomChild))}
                    error={
                      consumption?.consumptionObj?.warehouseErrors === true
                    }
                    onChange={(evt, val) => {
                      let key = buildKeyForChildProduct(bomChild);
                      if (val === null) {
                        let currentMapConsumptions =
                          screenStore.mapConsumptions;

                        let consumption = null;
                        consumption = findConsumptionByKey(
                          currentMapConsumptions,
                          key
                        );
                        if (consumption !== null) {
                          consumption.consumptionObj.Id_Warehouse = 0;
                          consumption.consumptionObj.warehouseErrors = false;
                          consumption.consumptionObj.Id_Lot = 0;
                          consumption.consumptionObj.lotErrors = false;
                          consumption.consumptionObj.warehouseErrors = false;
                          consumption.consumptionObj.showInsufficientQuantityAtLocationError =
                            false;
                        }

                        currentMapConsumptions = replaceConsumptionObjByKey(
                            currentMapConsumptions,
                            key,
                            consumption.consumptionObj
                          );
                        dispatchActionScreenAskBomConsumptionsStore({
                          type: "SET_MAP_CONSUMPTIONS",
                          payload: [...currentMapConsumptions],
                        });
                      } else {
                        let targetLabel = val.label;
                        let targetValue = val.value;

                        let newMapConsumptions = screenStore.mapConsumptions;

                        let consumption = null;
                        consumption = findConsumptionByKey(
                          newMapConsumptions,
                          key
                        );
                        let exists = true;

                        if (consumption === null) {
                          exists = false;
                          consumption = {
                            key: key,
                            consumptionObj: {
                              Id_Product: 0,
                              Quantity: 0,
                              Id_WarehouseLocation: 0,
                              Id_Warehouse: 0,
                              Id_Lot: 0,
                              temp_warehouseLocationLabel: "",
                              temp_warehouseLabel: "",
                              temp_lotLabel: "",
                            },
                          };
                        }

                        let code = val?.fetchedData?.code ? val?.fetchedData?.code : "";
                        let name = val?.fetchedData?.name ? val?.fetchedData?.name : "";

                        if(val?.fetchedData?.code){
                          targetLabel = "(" + code + ") " + name;
                        }

                        consumption.consumptionObj.Id_Product =  bomChild.Id_ProductChild;
                        consumption.consumptionObj.Quantity = consumption?.consumptionObj?.Quantity ? consumption?.consumptionObj?.Quantity : "";//bomChild.Quantity;
                        consumption.consumptionObj.Id_Warehouse = targetValue;
                        consumption.consumptionObj.temp_warehouseLabel =
                          targetLabel;
                        consumption.consumptionObj.warehouseErrors = false;
                        consumption.consumptionObj.lotErrors = false;
                        consumption.consumptionObj.showInsufficientQuantityAtLocationError =
                          false;
                        if (!exists) {
                          newMapConsumptions.push(consumption);
                        } else {
                          newMapConsumptions = replaceConsumptionObjByKey(
                              newMapConsumptions,
                              key,
                              consumption.consumptionObj
                            );
                        }
                        setLotSearchFilters({ Id_Warehouse: targetValue });

                        dispatchActionScreenAskBomConsumptionsStore({
                          type: "SET_MAP_CONSUMPTIONS",
                          payload: [...newMapConsumptions],
                        });

                        forceRerenderView();
                      }
                    }}
                    value={getWarehouseConsumptionField(buildKeyForChildProduct(bomChild))}
                    listJsonFunction={
                      warehouseController().getWarehousesListJson
                    }
                    listJsonOptions={getWhLocConsumptionListJsonOptions(bomChild)}
                    uniqueId={"wh_cons_tgt_stock_" + buildKeyForChildProduct(bomChild)}
                    labelPlaceholder={t("warehouse")}
                  />
                </div>
              ) : (
                <div>
                  <b>{t("warehouse")}:</b> ({currentActionConfig?.temp_warehouse_name}){" "}
                  {currentActionConfig?.temp_warehouse_name}
                </div>
              )}
              {allowManualStockLocationSelection || (allowChangeLot) ? (
                <div className={styles.selectorElem}>


                  <TextField
                  
                      className={styles.input}
                        fullWidth
                        error={consumption?.consumptionObj?.lotErrors === true}
                        onChange={(evt:any) => {
                          //updateLotName(bomChild,evt.target.value);
                          updateLocationConsumption(bomChild,{
                            newLotData:{
                              lotValue:evt.target.value
                            }
                          });
                        }}
                        value={
                          getLotConsumptionField(buildKeyForChildProduct(bomChild)) ?  getLotConsumptionField(buildKeyForChildProduct(bomChild)) : ""
                        }
                        label={t("lot")}
                        variant="outlined"
                      
                        
                    />
                    <div style={{display:'flex',flexWrap:'wrap'}}>
                    {currentActionScreenManager?.currentActionConfig?.existingLots === 1 && (
                      <>
                      <HxfExistingLotsButton 
                        productName={bomChild.childProduct_name} 
                        Id_Product={bomChild.Id_ProductChild}
                        arrayProductParameterizedVariables={bomChild?.arrayProductParameterizedVariables ? bomChild.arrayProductParameterizedVariables : []}
                        onLotSelection={(data:IExistLotResultLocation) => {
                          if(!data?.Id_Lot){
                            return;
                          }
                     
                          let updatingLocationData:any = {};
                          if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillLot === 1){
                            updatingLocationData.newLotData = { //for lots we only need the lot code directly as it is calculated in the backend
                              lotValue:data.lotCode
                            };
                          }
                          if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillWh === 1){
                            updatingLocationData.newWhData = { 
                              Id:data.Id_Warehouse,
                              code:data.warehouseCode,
                              name:data.warehouseName
                            };
                          }
                          if(currentActionScreenManager?.currentActionConfig?.exLotsOnSelFillWhLoc === 1){
                            updatingLocationData.newWhLocData = { 
                              Id:data.Id_WarehouseLocation,
                              code:data.warehouseLocationCode,
                              name:data.warehouseLocationName
                            };
                          }
                          updateLocationConsumption(bomChild,updatingLocationData);
                  
                        }}
                        />
                      </>
                      )
                    }

                    {currentActionScreenManager?.currentActionConfig?.stagedLotSuggestions === 1 && (
                      <>
                      <HxfStagedLotsButton 
                        stagedArrayMaterialComponentsData={getStagedMaterial()}
                        bomChild={{Id_ProductChild:bomChild.Id_ProductChild,childProduct_name:bomChild.childProduct_name,arrayProductParameterizedVariables: bomChild?.arrayProductParameterizedVariables ? bomChild.arrayProductParameterizedVariables : []}}
                        onLotSelection={(data:IExistLotResultLocation) => {
                          
                          if(!data?.Id_Lot){
                            return;
                          }
            
            
                         let updatingLocationData:any = {};
                          if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillLot === 1){
                            updatingLocationData.newLotData = { //for lots we only need the lot code directly as it is calculated in the backend
                              lotValue:data.lotCode
                            };
                          }
                          if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillWh === 1){
                            updatingLocationData.newWhData = { 
                              Id:data?.Id_Warehouse,
                              code:data?.warehouseCode,
                              name:data?.warehouseName
                            };
                          }
                          if(currentActionScreenManager?.currentActionConfig?.stgLotsOnSelFillWhLoc === 1){
                            updatingLocationData.newWhLocData = { 
                              Id:data?.Id_WarehouseLocation,
                              code:data?.warehouseCode,
                              name:data?.warehouseName
                            };
                          }
                         
                          updateLocationConsumption(bomChild,updatingLocationData);
                      
                        }}
                      />
                      </>)
                    }
                    </div>
                </div>
              ) : (
                <div>
                  <b>Lot:</b> ({currentActionConfig?.temp_lot_code}){" "}
                  {currentActionConfig?.temp_lot_name}
                </div>
              )}
            </div>
          )}



          {allowManualStockLocationSelection ||
          allowChangeWarehouseLocation ||
          allowChangeWarehouse ||
          allowChangeLot ? (
            <div></div>
          ) : (
            <></>
          )}
        </div>
      </>
    );
  };

  if (!productionOrderSelectionStore?.product?.product_BoM) {
    return (
      <>
        <div className={styles.container}>
          <ActionScreenTopBar
            callbackOnClose={props.callbackOnClose}
            title="Bill Of Material - Consumptions"
          />

          <div className={styles.content}>
            <div className={styles.label}>
              {t("no.bom.defined")}..
            </div>
          </div>
        </div>
      </>
    );
  }

  if(!didMount){
    return (<></>)
  }

  //todo map. productionOrderSelectionStore?.product?.product_BoM
  return (
    <>
      <div className={styles.container}>
        {(currentActionScreenManager?.currentActionConfig?.isFillerMode === 1 && (
          <>
            {addingFillConsumption !== null && addingFillConsumption._step === "STOCK_LOCATION" && (
              <>
                <DefineStockLocationPopup
                requireFillLocation={currentActionScreenManager?.currentActionConfig?.requireFillStockLocation === 1}
                  allowLotCreation={false}
                  title={t("stock.location")}
                  currentData={null}
                  onClosePopup={() => {
                    setAddingFillConsumption(null);
                  }}



                  onSuccessConfirm={(result:any) => {
                   
                      if (!result?.Id_Lot && result?.defaultNoLotObj) {
                        result.Id_Lot = result.defaultNoLotObj.Id_Lot;
                        result.temp_lotLabel =
                          "(" +
                          result.defaultNoLotObj.code +
                          ") " +
                          result.defaultNoLotObj.name;

                          result.lotData = {
                            code: result.defaultNoLotObj.code,
                            name: result.defaultNoLotObj.name
                          };
                      }

                      let newFillCons = {...addingFillConsumption,
                        Id_Lot:result.Id_Lot,
                        Id_Warehouse:result.Id_Warehouse,
                        Id_WarehouseLocation:result.Id_WarehouseLocation,
                        _step:"QUANTITY_SET"
                      };
                      
                      if(result?.lotData){
                        newFillCons.lotData = {code:result?.lotData?.code};
                      }

                      if(result?.warehouseData){
                        newFillCons.warehouseData = {code:result?.warehouseData?.code};
                      }
                      
                      setAddingFillConsumption(newFillCons);
                      console.log("success", result);
                  }}
                />
              </>
            )}

            {addingFillConsumption !== null && addingFillConsumption._step === "QUANTITY_SET" && (
                <DefineProductQuantityPopup
                  deprecatedModePopup={true}
                  qtyInputPlaceholder={t('quantity')}
                  productData={{name:addingFillConsumption.productName,code:addingFillConsumption.productCode,qtyValue:getMissingQty(addingFillConsumption.productKey)}}
                  title={t("quantity")}
                  onClosePopup={() => {
                    setAddingFillConsumption(null);
                  }}
                  onSuccessConfirm={(res: any) => {
                      console.log("QT RES: ",res);
                      let resultQuantity = res?.quantityResult ? res.quantityResult : 0;
                      if(resultQuantity === 0){
                        setAddingFillConsumption(null);
                        return;
                      }
                      let productKey = addingFillConsumption.productKey;
                      let idProduct = addingFillConsumption?.Id_Product;
                      let arrayProductParameterizedVariables = addingFillConsumption?.arrayProductParameterizedVariables;
                      let idWhLoc = addingFillConsumption?.Id_WarehouseLocation;
                      let idWh = addingFillConsumption?.Id_Warehouse;
                      let idLot = addingFillConsumption?.Id_Lot;

                      let newFillCons:any = {
                        Id_Product:idProduct,
                        arrayProductParameterizedVariables:arrayProductParameterizedVariables,
                        Quantity: resultQuantity,
                        Id_WarehouseLocation:idWhLoc,
                        Id_Warehouse:idWh,
                        Id_Lot:idLot,
                        lotData:addingFillConsumption?.lotData,
                        warehouseData:addingFillConsumption?.warehouseData,
                      };

                      if(addingFillConsumption?._isDefiningNewStockQty){
                        newFillCons._isDefiningNewStockQty = true;
                      }
                     
                      finishAddingFillConsumption(productKey, newFillCons); 
                  }}
                />
            )}
          </>
        ))}

        {isPhysScannerEnabled() && (
          <>{getPhysScanner()}</>
        )}
        
        <ActionScreenTopBar
          callbackOnClose={props.callbackOnClose}
          title={getProperTitle()}
        />
          <div className={styles.properSubtitle} style={getProperStyle()}>
            <div className={styles.iconTypeCons}>{getProperIcon()}</div>
                <div>{getProperSubtitle()}</div>

          </div>
        <div className={styles.content}>

         
          <div className={styles.tableArea}>
            <div className={styles.consumptionsTableContainer}>
              <div className={styles.consumptionsTableBody}>

                {getFullListingConsumptions()?.length === 0 ? (
                  <div className={styles.noConsumptionAv}>{t('no.consumptions.available')}</div>
                ) : (
                  <>
                  <div className={styles.consumptionsRow}>
                    <div
                      className={`${styles.consumptionsBodyCellHeader} ${styles.consumptionsLeftHeader}`}
                    >
                      {t("product")}
                    </div>
                    
                    <div className={`${styles.consumptionsBodyCellHeader}`}>
                      {t("quantity")}
                    </div>

                    {(currentActionScreenManager?.currentActionConfig?.isFillerMode === 1 || currentActionScreenManager?.currentActionConfig?.allowManualStockLocationSelection === 1 || currentActionScreenManager.currentActionConfig?.allowManualLotSet === 1) && (
                        <div
                        className={`${styles.consumptionsBodyCellHeader} ${styles.consumptionsRightHeader}`}
                      >
                        {t("stock.location")}
                      </div>
                    )}

                  </div>
                    {getFullListingConsumptions().map((obj: any, index: number) => (
                      <div
                        key={"bom_p_" + index}
                        className={styles.consumptionsRow}
                      >
                        
                        <div
                          className={`${styles.consumptionsBodyCell} ${styles.consumptionsCellProduct} ${styles.consumptionsProductCol} ${obj?.askUpdateConsLocStockQty === 1 ? styles.cellUpdateLocStockQty : ""}`}
                        >
                          <div className={`${styles.consumptionProductName}`}>
                            <div> ({obj.childProduct_code}) </div>
                            <div> {obj.childProduct_name} </div>
                          </div>
                          {getMapArrayFixedVariables(index).length > 0 && (
                            <div>
                              <div>
                                <div
                                  className={
                                    styles.consumptionsParameterizedVariablesLabel
                                  }
                                >
                                  <b>{t("fixedvariables")}:</b>
                                </div>
                                {getMapArrayFixedVariables(index).map(
                                  (objPv: any, indexPv: number) => (
                                    <div
                                      className={
                                        styles.consumptionsParameterizedVariablesAndValues
                                      }
                                      key={"bom_p_fv_" + indexPv}
                                    >
                                      {objPv.temp_labelPv}:{objPv.Value}
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          )}

                          {getArrayParameterizedVariables(index).length > 0 && (
                            <div>
                              <div>
                                <div
                                  className={
                                    styles.consumptionsParameterizedVariablesLabel
                                  }
                                >
                                  <b>{t("parameterizedvariables")}:</b>
                                </div>
                                {getArrayParameterizedVariables(index).map(
                                  (objPv: any, indexPv: number) => (
                                    <div
                                      className={
                                        styles.consumptionsParameterizedVariablesAndValues
                                      }
                                      key={"bom_p_pv_" + indexPv}
                                    >
                                      {objPv.name}:{objPv.Value}
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          )}

                          
                        </div>
                        <div className={`${styles.consumptionsBodyCell} ${obj?.askUpdateConsLocStockQty === 1 ? styles.cellUpdateLocStockQty : ""}`}>
    
                          <div className={styles.consumptionsQtyContainer}>

                            <div style={{width:'100%'}}>
                              {obj?.askUpdateConsLocStockQty === 1 ? (
                                <>
                                  <div>
                                      <div className={styles.updStockIcon}>
                                        <WarehouseIcon/>
                                      </div>
                                      <div className={styles.updStockLabel}>
                                        {t('stock.update')}
                                      </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                {currentActionScreenManager?.currentActionConfig?.isFillerMode === 1 ? (<>
                                    <div className={styles.consumptionsQty}>
                                
                                      <TaskProgressBarV2
                                            //fillerColor={isProductCompleted(obj) ? '#a0dca070' : null}
                                            fillerColor={getFillerColor(index)}
                                            width={"125px"}
                                            tasksDone={getFilledQuantity(index)}
                                            totalTasks={getFieldQuantityValue(index)}
                                            
                                      />
                                    </div>
                                  
                                  </>) : (<>
                                      <div className={styles.consumptionsQty}>
                                      {getFieldQuantity(index)}
                                      </div>
                                      {getShowInsufficientError(index)}

                                  </>)}
                                </>
                              )}


                            </div>
      
                          </div>
                        </div>

                        {(currentActionScreenManager?.currentActionConfig?.isFillerMode === 1 || currentActionScreenManager?.currentActionConfig?.allowManualStockLocationSelection === 1 || currentActionScreenManager.currentActionConfig?.allowManualLotSet === 1) && (
                            <div className={`${styles.consumptionsBodyCell} ${obj?.askUpdateConsLocStockQty === 1 ? styles.cellUpdateLocStockQty : ""}`}>
                              {currentActionScreenManager?.currentActionConfig?.isFillerMode === 1 ? (
                                <>{getFillerModeStockLocations(index)}</>
                              ) : (
                                <>{getStockLocationElement(index)}</>
                              )}
                              
                            </div>
                        )}
                
                      </div>
                    ))}
                  </>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      <ActionScreenAskBomConsumptionsConfirmationButtons
        //disabled={isEdittingQtyCons !== null}
        onClickConfirm={() => {
            clickConfirm();
        }}
      />
    </>
  );
}

export default ActionScreenAskBomConsumptions;
